import React from 'react';
import { isEmpty } from 'lodash/fp';
import { useTranslation } from 'react-i18next';
import { WarehousesComponent } from '../../../../generated/graphql';
import { NoContent } from '../../../../ui-kit';
import WarehousesListView from './WarehousesListView';

const WarehousesList = () => {
    const { t } = useTranslation();
    const noWarehousesTitle = t('No warehouse created');
    return (
        <WarehousesComponent>
            {({ data: { warehouses } }) => isEmpty(warehouses)
                ? <NoContent title={noWarehousesTitle} />
                : <WarehousesListView warehouses={warehouses} />}
        </WarehousesComponent>
    );
};

export default WarehousesList;
